import { useMemo } from 'react'

import { Offer } from '@wwt/entities/search-response'
import { searchRequestToUrlSearchParams } from '@wwt/shared/utils'

import { useSearchAPIStore } from '@/entities/search'

import { useDefaultTabName } from '../hooks/useDefaultTabName'

export const useOfferCardDefault = (offer: Offer) => {
	const searchRequest = useSearchAPIStore.use.searchRequest()
	const tabName = useDefaultTabName(offer)

	/**
	 * We can re-calculate url params on every change search request in api store
	 * because after change info in store we should made requst to server
	 */
	const urlParams = useMemo(() => {
		if (!searchRequest) {
			return new URLSearchParams()
		}

		const searchParamsWithoutHotelAndRoomIds = {
			...searchRequest,
			integrationsSearch: searchRequest.integrationsSearch.map(integration => {
				return {
					integrationName: integration.integrationName
				}
			})
		}

		return searchRequestToUrlSearchParams({
			search: searchParamsWithoutHotelAndRoomIds
		})
	}, [searchRequest])

	return useMemo(() => {
		const urlParamsForOffer = new URLSearchParams(urlParams)

		urlParamsForOffer.set('hotelId', offer.IDs.integrationHotelId)
		urlParamsForOffer.set('roomId', offer.IDs.integrationRoomId)
		urlParamsForOffer.set('integrationName', offer.IDs.integrationName)
		urlParamsForOffer.set('tab', tabName)

		return {
			pathname: '/room-offer',
			search: urlParamsForOffer.toString()
		}
	}, [
		offer.IDs.integrationHotelId,
		offer.IDs.integrationName,
		offer.IDs.integrationRoomId,
		urlParams,
		tabName
	])
}
